import React from 'react';
import { Button } from '@mui/material';

const SubmitButton = ({ children }) => {
  return (
    <Button
      type="submit"
      variant="contained"
      fullWidth
      sx={{
        bgcolor: 'blue.700',
        color: 'white',
        py: 1,
        borderRadius: 1,
        textTransform: 'none',
        '&:hover': {
          bgcolor: 'blue.800',
          transition: 'background-color 200ms',
        },
      }}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;